import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function HotPosts() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);

  return (
    <section className="bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-1">社区精选优质内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {hotArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}